export enum HEADING_TYPE {
  BORROWER_VIEWING_SINGLE_BORROWER = 'borrower-viewing-single-borrower',
  BORROWER_VIEWING_SINGLE_GUARANTOR = 'borrower-viewing-single-guarantor',
  BORROWER_VIEWING_MULTIPLE_BORROWER = 'borrower-viewing-multiple-borrower',
  BORROWER_VIEWING_MULTIPLE_GUARANTOR = 'borrower-viewing-multiple-guarantor',
  GUARANTOR_VIEWING_SINGLE_BORROWER = 'guarantor-viewing-single-borrower',
  GUARANTOR_VIEWING_SINGLE_GUARANTOR = 'guarantor-viewing-single-guarantor',
  GUARANTOR_VIEWING_MULTIPLE_BORROWER = 'guarantor-viewing-multiple-borrower',
  GUARANTOR_VIEWING_MULTIPLE_GUARANTOR = 'guarantor-viewing-multiple-guarantor',
}
